<template lang="pug">
.container-fluid.bg_light_blue.i_ptb_6.i_ptb_sm_8
  .container
    .cards_slider
      swiper.swiper-container(:options="swiperOption", ref="cardsSwiper")
        swiper-slide.swiper-slide(v-for="(card, index) in cards", :key="index")
          card(:item="card", :select="index == selectedIndex")
      svg-icon.swiper-prev.d-none.d-md-block(
        iconClass="arrow_left_large",
        className="icon",
        @click="prevClick"
      )
      svg-icon.swiper-prev.d-md-none(
        iconClass="arrow_left_mobile",
        className="icon",
        @click="prevClick"
      )

      svg-icon.swiper-next.d-none.d-md-block(
        iconClass="arrow_right_large",
        className="icon",
        @click="nextClick"
      )
      svg-icon.swiper-next.d-md-none(
        iconClass="arrow_right_mobile",
        className="icon",
        @click="nextClick"
      )
</template>

<script>
import Card from "@/components/product_combo/CardsSlider/Card";

export default {
  name: "CardsSlider",
  components: {
    Card,
  },
  props: {
    cards: Array,
    selectedIndex: Number,
  },
  data() {
    var self = this;

    //初始slider可見個數
    let views;
    let space;
    if (document.body.clientWidth <= 767) {
      views = 1;
      space = 0;
    } else if (document.body.clientWidth <= 1023) {
      views = 2;
      space = 10;
    } else {
      views = 3;
      space = 15;
    }

    return {
      swiperOption: {
        notNextTick: true,
        initialSlide: 0,
        spaceBetween: space,
        slidesPerView: views,
        loop: false,
        direction: "horizontal",
        grabCursor: false,
        setWrapperSize: true,
        autoHeight: false,
        mousewheelControl: true,
        observeParents: true,
        debugger: true,
        paginationClickable: true,
        on: {
          resize: function () {
            self.updateSliders();
            this.update();
          },
          click: function () {
            if (document.body.clientWidth > 767) {
              self.updateIndex(this.clickedIndex % self.cards.length);
            }
          },
        },
      },
    };
  },
  computed: {
    cardsSwiper() {
      return this.$refs.cardsSwiper.$swiper;
    },
  },
  watch: {
    selectedIndex() {
      this.slideToSelectedItem();
    },
  },
  methods: {
    prevClick() {
      this.cardsSwiper.slidePrev();
      if (document.body.clientWidth <= 767) {
        this.updateIndex(this.cardsSwiper.activeIndex);
      }
    },
    nextClick() {
      this.cardsSwiper.slideNext();
      if (document.body.clientWidth <= 767) {
        this.updateIndex(this.cardsSwiper.activeIndex);
      }
    },
    updateSliders() {
      if (document.body.clientWidth <= 767) {
        this.cardsSwiper.params.slidesPerView = 1;
        this.cardsSwiper.params.spaceBetween = 0;

        this.slideToSelectedItem();
      } else if (document.body.clientWidth <= 1023) {
        this.cardsSwiper.params.slidesPerView = 2;
        this.cardsSwiper.params.spaceBetween = 10;
      } else {
        this.cardsSwiper.params.slidesPerView = 3;
        this.cardsSwiper.params.spaceBetween = 15;
      }
    },
    slideToSelectedItem() {
      this.cardsSwiper.slideToLoop(this.selectedIndex);
    },

    updateIndex(index) {
      this.$emit("update:selectedIndex", index);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/product_combo/cards_slider";
</style>
